import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend) // load translations via HTTP
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "fa",
    supportedLngs: ["fa"],
    defaultNS: "common",
    ns: [
      "common",
      "auth",
      "home",
      "orders",
      "products",
      "customers",
      "settings",
      "billing",
      "profile",
      "checkout",
      "terms",
      "shops",
      "commission",
      "instagram",
    ],

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;
